import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { identityRequest, IdentityCapabilities } from "../../services/physicalIdentityApi";

export default function EntityIdentityBadge({ productUniqueId }: { productUniqueId: string }) {
  const [entry, setEntry] = useState<{ identityCode?: string; resolverPath?: string }>();
  useEffect(() => {
    let live = true; setEntry(undefined);
    identityRequest<IdentityCapabilities>("/capabilities").then(async caps => {
      if (!caps.enabled || !caps.productBinding || !productUniqueId) return;
      const result = await identityRequest<{ identityCode?: string; resolverPath?: string }>(`/entities/PRODUCT/${encodeURIComponent(productUniqueId)}`);
      if (live) setEntry(result);
    }).catch(() => undefined); // Optional rollout badge must not break the existing Product view.
    return () => { live = false; };
  }, [productUniqueId]);
  return entry ? <p><Link to={entry.resolverPath || "/physical-identities"}>{entry.identityCode ? `Physical identity: ${entry.identityCode}` : "Scan a label to bind this Product"}</Link></p> : null;
}
